import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import './dropdown.scss'
import { useWindowSize } from '../../../../hooks/useWindowSize'
import { useMenuContext } from '../../../../context/MenuContext'
import Loader from '../../../../components/Loader/Loader'
import { DONATE_ROUTE } from '../constant'

const Dropdown: React.FC<DropdownProps> = ({
  navIndex,
  setsubActiveNav,
  subActiveNav,
  isMobile,
  setnavMobile,
}) => {
  const parser = new DOMParser()
  const navigate = useNavigate()
  let { menu, loader } = useMenuContext()
  const width = useWindowSize()
  const [path, setpath] = useState('')
  const location = useLocation()
  const { id, tag } = useParams()
  let nav = menu?.find((item: any) => item?.uid === navIndex)
  const getNavItems = () => {
    if (nav?.category === 'blog') {
      let subnav = nav?.subCategory?.map((item: any) => ({ ...item, tag: item?.title, category:  nav?.category }))
      return subnav?.sort((a: any, b: any) => a?.nav_order - b?.nav_order)
    } else {
      let subnav = nav?.subCategory?.map((item: any) => ({ ...item, category: nav?.category }))
        ?.sort((a: any, b: any) => a?.nav_order - b?.nav_order)
      return subnav
    }
  }

  let subNavItems = getNavItems()

  let isForMobile = width <= 1200
  useEffect(() => {
    const parentId=location.pathname.split('/')[1]
    if (parentId) {
      setpath(parentId)
    }    
  }, [location])

  const checkSubMenuId = useMemo(() => {
    if (tag && subNavItems?.length) {
      
      const blogTag = subNavItems.find((item: any) =>  item.tag === tag)
      return blogTag?.uid ?? null;
    }
    return id;
  }, [id, tag, subNavItems])

  if ((subNavItems?.length === 0 || !subNavItems) && !isMobile) {
    // to hide the dropdown
    return null
  }

  if (isForMobile && !isMobile) {
    return null
  }


  const clickHandler = (item: any) => {
    setsubActiveNav(item?.uid)
    setnavMobile(false)

    if (item.uid === 'donate') {
      /**
       * Adding page from the CMS
       */
      window.location.href = DONATE_ROUTE
      return null;
    }
    // Adding check of category so we can decide its parent category on breadcrumb
    if (item.uid === "dream-notes" && item.category === 'in-arena-messages') {
      return navigate(`/in-arena-messages/${item.uid}`)
    }
    if (item.uid === "dream-notes" && item.category === 'get-involved') {
      return navigate(`/get-involved/${item.uid}`)
    }
    if (item.uid === 'blog') {
      return navigate(`/${item.uid}`)
    }
    if (item.hasOwnProperty('tag') && item?.tag !== 'Blog') {
      navigate(`/blog/tag/${encodeURIComponent(item.title)}`)
    } else navigate(`${navIndex}/${item?.uid}`)
  }

  if (loader) {
    return <Loader />
  }
  return (
    <span className='nav--dropdown'>
      <li className='nav-item dropdown blue-strip-active-menu' id='blue-strip-active-menu'>
        <ul className={`dropdown-menus show content--navbar`}>
          {subNavItems?.map((item: any, index: any) => {
            return (
              <li key={index} id={item?.title} className='listScroll'>
                <button
                  className={`dropdown-item ${checkSubMenuId === item?.uid ? 'dropwdown--active' : ''}`}
                  onClick={() => clickHandler(item)}
                >
                  { parser?.parseFromString(item?.title, 'text/html')?.body?.textContent}
                </button>
              </li>
            )
          })}
        </ul>
      </li>
    </span>
  )
}

type DropdownProps = {
  navIndex?: any
  setsubActiveNav: (active: any) => void
  subActiveNav?: any
  isMobile?: boolean
  setnavActive?: (active: any) => void
  setnavMobile: (active: any) => void
}

export default Dropdown
